import { render, staticRenderFns } from "./f-collections.vue?vue&type=template&id=64b44d31&lang=pug&"
import script from "./f-collections.vue?vue&type=script&lang=js&"
export * from "./f-collections.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./f-collections.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b44d31')) {
      api.createRecord('64b44d31', component.options)
    } else {
      api.reload('64b44d31', component.options)
    }
    module.hot.accept("./f-collections.vue?vue&type=template&id=64b44d31&lang=pug&", function () {
      api.rerender('64b44d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-collections.vue"
export default component.exports